import Images from "../../media/images";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAd } from "../../features/adSlice/adSlice";

const SkipAdsModal = ({ isOpen, setIsOpen }) => {
  //   const [isOpen, setIsOpen] = useState(true);
  const ad = useSelector((state) => state.ad);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAd());

  }, [dispatch]);
  console.log("ad",ad)
  return (
    <div>
      {isOpen && (
        <>
          <div className="">
            <div className="max-w mt-10 grid w-full place-content-center">
              <div className="mt-3 flex items-end justify-between">
                <p className="text-sm text-primary-blue font-Acme">
                  ADVERTISEMENT
                </p>
                <button
                  onClick={() => setIsOpen(false)}
                  className="bg-primary-red font-Berkshire rounded-2xl py-2 px-4 text-white"
                >
                  Skip This
                </button>
              </div>
              {/* ad image */}
              <div className="mt-5">

              {ad.data
          ?.filter((item) => item.type === "square").slice(0,1)
          .map((item, index) => {
            console.log("ad detail",item)
            return (
          
              <img
              src={item.image}
              className="h-full w-full object-contain"
              alt=""
            />
          
            );
          })}
              
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default SkipAdsModal;
